import React from 'react';
import {withRouter} from "react-router-dom"
import {BodySm, TitleXl, TitleSm, Row, Col6} from "components/elements";
import {AboutUsBottomContainer, TitleXlContainer, TitleSmContainer, BodySmContainer, ColWrapper, RowContainer, NumbersContainer} from './elements';
import { dataObject } from './data';

function AboutUsBottomWhiteSection(props) {


return(
    <AboutUsBottomContainer>
        <TitleXlContainer>
            <TitleXl fontWeight="900">
                You can’t raise standards without having high standards for yourself. 
            </TitleXl>
        </TitleXlContainer>
        <RowContainer>
        <Row>
           {dataObject?.map((data, index) => (
            <Col6 key={index}>
                <ColWrapper>
                    <NumbersContainer>
                        <TitleSm>
                            {data.number}
                        </TitleSm>
                    </NumbersContainer>
                    <TitleSmContainer>
                        <TitleSm>
                            {data.title}
                        </TitleSm>
                    </TitleSmContainer>
                    <BodySmContainer>
                        <BodySm>
                        {data.body}
                        </BodySm>
                   </BodySmContainer>
                </ColWrapper>
            </Col6>
           ))}        
        </Row>
        </RowContainer>
    </AboutUsBottomContainer>
    )
}

export default withRouter(AboutUsBottomWhiteSection);
